export default function getAsset(path: string) {
  return process.env.REACT_APP_ORIGIN + "/" + path;
}
